import { useOverlayState } from "@heroui/react";
import { Menu } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router";
import { Button, Drawer } from "@/src/common/components/ui";
import { StaffSidebar } from "@/src/staff/components/staff-sidebar";

export function StaffLayout() {
	const { t } = useTranslation("staff");
	const drawerState = useOverlayState();

	return (
		<div className="flex h-screen overflow-hidden">
			<div className="hidden md:flex">
				<StaffSidebar />
			</div>

			<div className="flex flex-1 flex-col overflow-hidden">
				<header className="flex items-center justify-between border-b border-divider px-4 py-3 md:hidden">
					<p className="text-sm font-semibold">{t("sidebar.title")}</p>
					<Button variant="ghost" size="sm" onPress={drawerState.open} aria-label={t("sidebar.title")}>
						<Menu size={18} />
					</Button>
				</header>
				<main className="flex-1 overflow-auto">
					<Outlet />
				</main>
			</div>

			<Drawer state={drawerState}>
				<Drawer.Backdrop isDismissable className="md:hidden">
					<Drawer.Content placement="left">
						<Drawer.Dialog className="w-72 max-w-none">
							<Drawer.Body className="p-0">
								<StaffSidebar onNavigate={drawerState.close} />
							</Drawer.Body>
						</Drawer.Dialog>
					</Drawer.Content>
				</Drawer.Backdrop>
			</Drawer>
		</div>
	);
}
